import { Component, OnInit } from '@angular/core';
import { SmoochService } from 'src/app/services/smooch.service';
import { Observable } from 'rxjs';
import { Webhook } from 'src/app/models/webhook';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-webhook-list',
  templateUrl: './webhook-list.component.html',
  styleUrls: ['./webhook-list.component.scss']
})
export class WebhookListComponent implements OnInit {

  webhooks$: Observable<Webhook[]>;

  constructor(
    private _smoochService: SmoochService,
    private _snackBar: MatSnackBar
  ) { 
    this.webhooks$ = _smoochService.webhooks$;
  }

  ngOnInit() {
  }

  trackByFn(index: number, webhook: Webhook) {
    return webhook._id;
  }

  delete(webhook: Webhook) {
    this._smoochService.deleteWebhook(webhook._id)
      .subscribe(() => {
        this._snackBar.open(`Deleted webhook ${webhook._id}.`);
      }, (err) => {
        const errorMessage = `Failed to delete webhook ${webhook._id}`;
        console.log(errorMessage, err);
        this._snackBar.open(errorMessage);
      });
  }
}
